import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import api from "@/lib/api";
import { AdminTitle } from "@/pages/admin/AdminUI";

export default function AdminAudit() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/admin/audit-logs").then((r) => setItems(r.data)).catch(() => setItems([])); }, []);
  if (items === null) return <div className="flex justify-center py-20"><Loader2 className="animate-spin text-amber-400" size={36} /></div>;
  return (
    <div>
      <AdminTitle title="Audit Log" />
      <div className="card-lux overflow-x-auto">
        <table className="w-full text-sm min-w-[640px]" data-testid="admin-audit-table">
          <thead className="bg-black/30 text-slate-500 text-xs uppercase"><tr><th className="text-left px-5 py-3">Admin</th><th className="text-left px-5 py-3">Action</th><th className="text-left px-5 py-3">Target</th><th className="text-left px-5 py-3">IP</th><th className="text-left px-5 py-3">Time</th></tr></thead>
          <tbody>
            {items.map((a) => (
              <tr key={a.id} className="border-t border-white/5">
                <td className="px-5 py-3 text-slate-400">{a.admin_email}</td>
                <td className="px-5 py-3 text-white">{a.action}</td>
                <td className="px-5 py-3 text-slate-400">{a.target}</td>
                <td className="px-5 py-3 text-slate-600 font-mono text-xs">{a.ip || "—"}</td>
                <td className="px-5 py-3 text-slate-600 text-xs">{(a.created_at || "").slice(0, 16).replace("T", " ")}</td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan={5} className="px-5 py-10 text-center text-slate-500">No audit entries yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
